import { EDITOR } from 'constants/actionTypes';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';

const integrationRequest = () => ({
  type: EDITOR.INTEGRATIONS.DATA_REQUEST,
});

const integrationReceive = payload => ({
  type: EDITOR.INTEGRATIONS.DATA_RECEIVE,
  payload,
});

const integrationFailure = error => ({
  type: EDITOR.INTEGRATIONS.DATA_FAILURE,
  error,
});

export const fetchIntegration = appIndicator => {
  return async dispatch => {
    dispatch(integrationRequest);
    try {
      const response = await request.get(routes.ENABLED_INTEGRATIONS.CHECK, {
        app_indicator: appIndicator,
      });
      dispatch(integrationReceive(response));
    } catch (error) {
      dispatch(integrationFailure(error));
    }
  };
};
